import { AxiosPromise } from "axios";
import { dashboardApiConfig, ops } from "./config";
import {
  BrandDto,
  BrandsResourceApi,
  BrandLogoDto,
  BrandBackgroundImageDto,
  BrandUploadedFontDto,
} from "../generated/dashboard-client";

const api = new BrandsResourceApi(dashboardApiConfig);

const BrandsApi = {
  getBrand(id: string): AxiosPromise<BrandDto> {
    return api.getBrand(id, ops());
  },
  getBrandPerLocation(locationId: number): AxiosPromise<BrandDto> {
    return api.getBrandPerLocation(locationId, ops());
  },
  createBrand(dto: BrandDto): AxiosPromise<BrandDto> {
    return api.createBrand(dto, ops());
  },
  updateBrand(dto: BrandDto): AxiosPromise<BrandDto> {
    return api.updateBrand(dto, ops());
  },
  deleteBrand(id: string): AxiosPromise<void> {
    return api.deleteBrand(id, ops());
  },
  clearBrand(id: string): AxiosPromise<BrandDto> {
    return api.clearBrand(id, ops());
  },
  copyFromLocation(id: string, copyFromLocId: number): AxiosPromise<BrandDto> {
    return api.copyFromLocation(id, copyFromLocId, ops());
  },
  uploadLogo(id: string, file: File): AxiosPromise<BrandLogoDto> {
    return api.uploadLogo(id, file, ops());
  },
  uploadBackgroundImage(id: string, file: File): AxiosPromise<BrandBackgroundImageDto> {
    return api.uploadBackgroundImage(id, file, ops());
  },
  updateBrandLogos(brandId: string, logoId: string): AxiosPromise<void> {
    return api.updateBrandLogos(brandId, logoId, ops());
  },
  deleteLogo(logoId: string): AxiosPromise<void> {
    return api.deleteBrandLogo(logoId, ops());
  },
  updateLogoAltText(logoId: string, altText: string): AxiosPromise<BrandLogoDto> {
    return api.updateLogoAltText(logoId, altText, ops());
  },
  uploadFont(brandId: string, file: File): AxiosPromise<BrandUploadedFontDto> {
    return api.uploadFont(brandId, file, ops());
  },
  deleteFont(uploadedFontId: string): AxiosPromise<void> {
    return api.deleteBrandUploadedFont(uploadedFontId, ops());
  },
};

export default BrandsApi;
